/**
* Specials Archive JS
* -----------------------------------------------------------------------------
*
* All the JS for the Specials Archive component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'locations-menu',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).on( 'submit', '#search-locations-form', function( e ) {
        e.preventDefault();
        $.ajax( {
          type: 'POST',
          url: siteInfo.wpApiSettings.ll + 'locations/search',
          data: {
            searchVal: $( 'input[name="searchVal"]' ).val(),
            geofli: Geofli.stores,
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.locations-list' ).empty( );
            $( '.locations-list' ).append( data.html );

            // $( '.user-store-selector' ).each( function() {
            //   const $el = $( this );
            //   $el.on( 'click', function() {
            //     const target = $( 'button[data-toggle-trigger-off="#locations-menu]' );
            //     $( '.close-locations-menu' ).trigger( 'click' );
            //   } );
            // } );
          },
          complete: function( jqXHR, status ) {
            $( '.loader' ).removeClass( 'is-loading' );
            doingAjax = false;
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'locations-menu', COMPONENT );
} )( app );
